<template>
  <div class="breadarea">
    <div class="pic" v-if="pic">
      <div>
        <p v-html="eng"></p>
        <h1 v-html="title"></h1>
      </div>
      <img :src="pic" :alt="title">
    </div>
    <div class="bread">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.breadarea{
  position: relative;
  top: 0;
  left: 0;
  .pic{
    position: relative;
    padding: 8.8rem 8vw;
    min-height: 20rem;
    overflow: hidden;
    @include module.flex();
    align-items: center;
    @media screen and (max-width: module.$tab){
      min-height: 18rem;
      padding: 3.6rem 8vw;
    }
    @media screen and (max-width: module.$phone){
      min-height: 14rem;
    }
    &:before{
      content: '';
      width: 100%;
      height: 100%;
      background: #000;
      position: absolute;
      top: 0;
      left: 0;
      opacity: .12;
      z-index: 2;
    }
    img{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    div{
      color: module.$white;
      line-height: 1.4;
      font-weight: 700;
      position: relative;
      z-index: 10;
      transform: translateY(-1rem);
      p{
        font-size: 4.6rem;
        @media screen and (max-width: module.$tab){
          font-size: 2.8rem;
        }
        @media screen and (max-width: module.$phone){
          font-size: 2.4rem;
        }
      }
      h1{
        font-size: 1.24rem;
        @media screen and (max-width: module.$tab){
          font-size: 1.12rem;
        }
        @media screen and (max-width: module.$phone){
          font-size: 1rem;
        }
      }
    }
  }
  
  .bread{
    position: absolute;
    left: module.side();
    bottom: 1.6rem;
    z-index: 10;
  }
}
</style>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false
    },
    eng: {
      type: String,
      required: false
    },
    pic: {
      type: String,
      required: false
    },
  }
}
</script>
